import { type UseQueryResult, useQuery } from 'react-query';
import { type SortByType } from '../../constants/common';
import {
  StockService,
  // eslint-disable-next-line camelcase
  type Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto,
} from '@wealthlane/api-services/wealthlane-finance-integration-service';

const useGetStockForCustomer = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  stockFilter?: SortByType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDetailDto[] | undefined,
  unknown
> => {
  const stockApi = useQuery(['getStockForCustomerData', stockFilter], async () => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (stockFilter) {
      if (stockFilter === '1M') {
        return await handleRequest(
          StockService.getApiFinanceIntegrationApiAppStockOneMonthStockData()
        );
      }
      if (stockFilter === 'YTD') {
        return await handleRequest(
          StockService.getApiFinanceIntegrationApiAppStockYearToDateStockData()
        );
      }
      if (stockFilter === '1Y') {
        return await handleRequest(
          StockService.getApiFinanceIntegrationApiAppStockOneYearStockData()
        );
      }
      if (stockFilter === '3Y') {
        return await handleRequest(
          StockService.getApiFinanceIntegrationApiAppStockThreeYearStockData()
        );
      }
      if (stockFilter === '5Y') {
        return await handleRequest(
          StockService.getApiFinanceIntegrationApiAppStockFiveYearStockData()
        );
      }
    }
  });
  return stockApi;
};

export default useGetStockForCustomer;
